// Record events for the walkthroughs (T1-02b): a tiny emitter. The realtime socket and the create hook feed it, and a
// tour host subscribes to know when a record it is teaching has changed.

export type RecordEvent = { c: string; id: string; op: "c" | "u" | "d"; by?: string };

const handlers = new Set<(e: RecordEvent) => void>();

export function emitRecordEvent(e: RecordEvent): void {
  for (const h of handlers) {
    try {
      h(e);
    } catch {
      /* one failing listener never stops the others */
    }
  }
}

/** Subscribes to record events; the returned function unsubscribes. */
export function onRecordEvent(h: (e: RecordEvent) => void): () => void {
  handlers.add(h);
  return () => {
    handlers.delete(h);
  };
}
